import { Box, Typography } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { GridToolbarExport } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import useMedia from '../../hooks/useMedia';
import { numberFormatter } from '../../utils';
import BookingsDropdown from '../dropdown/BookingsDropdown';

interface BookingsTableToolbarProps {
  overallPaid: number;
  overallBalance: number;
  chosenYear: number;
  availableYears: number[];
  handleChange: (event: SelectChangeEvent) => void;
}

const BookingsTableToolbar: FC<BookingsTableToolbarProps> = observer(props => {
  const {
    overallPaid,
    overallBalance,
    chosenYear,
    availableYears,
    handleChange,
  } = props;

  const isMobile = useMedia('md');

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      justifyContent="space-between"
      p={2}
      pl={isMobile ? 0 : 16.5}
      mt={-8}
    >
      <Box p={1} sx={{ width: 'auto', alignSelf: 'center' }}>
        <Typography
          variant="body1"
          component="h6"
          align="left"
          color="secondary"
        >
          {`Vorgeschriebene Beträge: ${numberFormatter(overallBalance)} €`}
        </Typography>
        <Typography
          variant="body1"
          component="h6"
          align="left"
          color="secondary"
        >
          {`Bezahlte Beträge : ${numberFormatter(overallPaid)} €`}
        </Typography>
        <Typography
          variant="body1"
          component="h6"
          align="left"
          color="secondary"
        >
          {`Saldo: ${numberFormatter(
            Math.abs(overallBalance) - Math.abs(overallPaid),
          )} €`}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        p={2}
        gap="2rem"
        alignItems="center"
      >
        <BookingsDropdown
          selectedValue={String(chosenYear)}
          handleChange={handleChange}
          availableYears={availableYears}
        />
        {!isMobile && (
          <GridToolbarExport
            printOptions={{ disableToolbarButton: true }}
            csvOptions={{
              delimiter: ';',
              utf8WithBom: true,
            }}
          />
        )}
      </Box>
    </Box>
  );
});
export default BookingsTableToolbar;
